import type { ReactNode } from "react";
import { NodeViewWrapper } from "@tiptap/react";
import type { NodeViewProps } from "@tiptap/react";
import { Popover } from "../../../../components/Popover";
import type { RichTextEditorMentionOption } from "../types";

type MentionNodeViewProps = NodeViewProps & {
  renderHoverContent?: (option: RichTextEditorMentionOption) => ReactNode;
};

export const MentionNodeView = ({
  node,
  renderHoverContent,
}: MentionNodeViewProps) => {
  const option: RichTextEditorMentionOption = {
    id: node.attrs.id as string,
    label: node.attrs.label as string,
  };
  const label = `@${option.label}`;

  if (!renderHoverContent) {
    return (
      <NodeViewWrapper as="span">
        <button type="button" data-type="mention">
          {label}
        </button>
      </NodeViewWrapper>
    );
  }

  return (
    <NodeViewWrapper as="span">
      <Popover openOnHover placement="bottom">
        <Popover.Trigger>
          {(props) => (
            <button type="button" data-type="mention" {...props}>
              {label}
            </button>
          )}
        </Popover.Trigger>
        <Popover.Content>{renderHoverContent(option)}</Popover.Content>
      </Popover>
    </NodeViewWrapper>
  );
};

MentionNodeView.displayName = "MentionNodeView";
